import * as React from "react"

import { cn } from "@/lib/utils"

const inputSizes = {
  xs: "h-7 px-2 text-xs",
  sm: "h-8 px-2.5 text-xs",
  default: "h-9 px-3 py-1 text-base md:text-sm",
  lg: "h-11 px-3 text-base",
}

const Input = React.forwardRef(({ className, type, size = "default", ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex w-full rounded-md border border-input bg-transparent shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/60 placeholder:italic focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        inputSizes[size] || inputSizes.default,
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
